<template>
  <a-modal
    class="preview-image"
    :width="width"
    :visible="previewVisible"
    :footer="null"
    @cancel="previewVisible = false"
    :closable="false"
  >
    <img class="img" :src="imageSrc" />
  </a-modal>
</template>
<script>
  import Vue from 'vue'
  import Viewer from 'v-viewer'
  import 'viewerjs/dist/viewer.css'
  import { UPLOAD_CDN_HOST } from '@/config/env'
  import defaultImg from 'assets/images/default_img.png'
  Vue.use(Viewer)

  export default {
    name: 'previewImage',
    data() {
      return {
        width: 400,
        previewVisible: false,
        imageSrc: '',
        defaultImg: defaultImg,
        baseUrl: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV],
      }
    },
    methods: {
      /**
       * @param {String|Array} src 图片地址
       * @param {Number} type 1单图预览(模态框的方式) | 2可操作的预览(底部带操作按钮)
       */
      previewImage(src = '', type = 1) {
        const img = Array.isArray(src) ? src[0] : src
        const images = this.filterUrl(img)
        if (type === 1) {
          this.previewVisible = true
          this.imageSrc = images
        } else {
          this.$viewerApi({
            images: [images],
          })
        }
      },
      /**
       * 过滤图片
       * @param val
       */
      filterUrl(val) {
        let url = ''
        if (!val || ['null!imageslim', 'null', '!imageslim'].includes(val)) {
          url = defaultImg
        } else if (val.indexOf('://') > -1 || val.indexOf('//') > -1) {
          url = val
        } else {
          url = this.baseUrl + val
        }
        val = url
        return url
      },
    },
  }
</script>
<style lang="scss">
  .preview-image {
    .img {
      width: 100%;
    }
  }
</style>
